<template>
  <div class="mt-component-form">
    <vs-row class="my-4 header-flex">
      <h5><i class="dot"></i>{{ getTableTitle }}</h5>
      <div class="header-buttons">
        <!-- Desktop: 항목추가 + 선택삭제 -->
        <vs-button
          v-if="!isPrint && !isReadonly"
          class="desktop-only"
          color="secondary"
          type="border"
          @click="handleAddRow"
        >항목추가
        </vs-button>
        <!-- PC/Mobile 공통: 선택삭제 -->
        <vs-button
          v-if="!isPrint && !isReadonly"
          class="ml-4"
          color="secondary"
          :disabled="selectedItemsCount === 0"
          @click="handleRemoveRowConfirm"
        >선택삭제
        </vs-button>
      </div>
    </vs-row>

    <!-- 빈 목록 안내 메시지 -->
    <div v-if="riskList.length === 0 && !isPrint" class="empty-list-message">
      <div class="empty-content">
        <i class="feather icon-inbox empty-icon"></i>
        <p class="empty-text">항목을 추가해주세요</p>
        <vs-button
          color="primary"
          type="filled"
          @click="handleAddRow"
          class="empty-add-btn"
        >
          <i class="feather icon-plus mr-2"></i>
          첫 번째 항목 추가
        </vs-button>
      </div>
    </div>

    <!-- Desktop 테이블 레이아웃 -->
    <div class="form-group grid desktop-layout">
      <div class="overflow-x-auto">
        <!--        header-->
        <div class="row-header"
             style="display: grid;"
             :style="{gridTemplateColumns:isPrint || isReadonly?'repeat(6, 1fr)':'40px repeat(6, 1fr)'}" >
          <div v-if="!isPrint && !isReadonly" class="row-header__item row-color-content">
            <vs-checkbox
              @change="handleCheckAll"
              v-model="allCheck"
            ></vs-checkbox>
          </div>
          <div class="row-header__item">업체명</div>
          <div class="row-header__item">주요 위험요인</div>
          <div class="row-header__item">재해형태</div>
          <div class="row-header__item">개선대책</div>
          <div class="row-header__item">개선일정</div>
          <div class="row-header__item">개선책임자</div>
        </div>

        <!--        rows-->
        <div
          class="row-content"
          style="display: grid; "
          :style="{gridTemplateColumns:isPrint || isReadonly?'repeat(6, 1fr)':'40px repeat(6, 1fr)'}"
          v-for="(row, indexRows) in riskList"
          :key="indexRows"
        >

          <div v-if="!isPrint && !isReadonly" class="none-border-center row-color-content">
            <vs-checkbox v-model="row.is_checked" :readonly="isReadonly"></vs-checkbox>
          </div>

          <div class="p-2">
            <span v-if="isPrint" class="print-input"> {{ row.input_1 }} </span>
            <CompanySelector
              v-else
              :readonly="isReadonly"
              class="w-full flex-1"
              v-model="row.input_1"
              placeholder="선택"
            ></CompanySelector>
          </div>

          <div class="p-2">
            <p v-if="isPrint" class="print-textarea">
              {{ row.input_2 }}
            </p>
            <ml-textarea
              class="m-0"
              :readonly="isReadonly"
              v-else

              rows="3"
              v-model="row.input_2"
            />
          </div>

          <div class="p-2">
            <p v-if="isPrint" class="print-input">
              {{ row.input_3 }}
            </p>
            <disaster-class-selector
              v-else
              class="w-full"
              :readonly="isReadonly"
              v-model="row.input_3"
            />
          </div>

          <div class="p-2">
            <p v-if="isPrint" class="print-textarea">
              {{ row.input_4 }}
            </p>
            <ml-textarea
              class="m-0"
              :readonly="isReadonly"
              v-else

              rows="3"
              v-model="row.input_4"
            />
          </div>

          <div class="p-2">
            <date-selector v-model="row.input_5" :readonly="isReadonly || isPrint"/>
          </div>

          <div class="flex-1 p-2">
            <p v-if="isPrint" class="print-input">
              {{ row.input_6 }}
            </p>
            <ml-input
              v-else
              :readonly="isReadonly"
              class="w-full"
              v-model="row.input_6"
            />
          </div>

        </div>

      </div>
    </div>

    <!-- Mobile 카드 레이아웃 -->
    <div class="mobile-layout">
      <!-- 모바일 전체 선택 헤더 (아이템이 있을 때만) -->
      <div
        class="mobile-header"
        v-if="!isPrint && !isReadonly && riskList.length > 0"
        @click="toggleAllCheck"
      >
        <vs-checkbox :value="allCheck" />
        <span class="mobile-header-text">전체 선택</span>
      </div>

      <!-- 모바일 카드형 아이템들 -->
      <div class="mobile-cards-container">
        <div
          v-for="(row, indexRows) in riskList"
          :key="indexRows"
          class="mobile-card"
          :class="{ 'selected': row.is_checked, 'print-mode': isPrint }"
        >
          <!-- 카드 헤더 (체크박스 + 인덱스 + 삭제 버튼) -->
          <div class="mobile-card-header" v-if="!isPrint && !isReadonly">
            <div class="mobile-card-header-left">
              <vs-checkbox v-model="row.is_checked"></vs-checkbox>
              <span class="card-index">{{ indexRows + 1 }}번째 항목</span>
            </div>
            <vs-button
              class="mobile-delete-btn"
              color="danger"
              type="flat"
              size="small"
              @click="handleDeleteSingleItem(indexRows)"
            >
              삭제
            </vs-button>
          </div>
          <div class="mobile-card-header print-header" v-else>
            <span class="card-index">{{ indexRows + 1 }}번째 항목</span>
          </div>

          <!-- 카드 내용 -->
          <div class="mobile-card-content">
            <!-- 업체명 -->
            <div class="mobile-field">
              <label class="mobile-field-label">업체명</label>
              <div class="mobile-field-input">
                <CompanySelector
                  v-if="!isPrint"
                  :readonly="isReadonly"
                  class="w-full"
                  v-model="row.input_1"
                  placeholder="선택"
                ></CompanySelector>
                <span v-else class="mobile-print-value">{{ row.input_1 }}</span>
              </div>
            </div>

            <!-- 주요 위험요인 -->
            <div class="mobile-field">
              <label class="mobile-field-label">주요 위험요인</label>
              <div class="mobile-field-input">
                <ml-textarea
                  v-if="!isPrint"
                  :readonly="isReadonly"
                  rows="3"
                  v-model="row.input_2"
                  class="w-full"
                  placeholder="주요 위험요인을 입력하세요"
                />
                <span v-else class="mobile-print-value mobile-print-textarea">{{ row.input_2 }}</span>
              </div>
            </div>

            <!-- 재해형태 -->
            <div class="mobile-field">
              <label class="mobile-field-label">재해형태</label>
              <div class="mobile-field-input">
                <disaster-class-selector
                  v-if="!isPrint"
                  class="w-full"
                  :readonly="isReadonly"
                  v-model="row.input_3"
                />
                <span v-else class="mobile-print-value">{{ row.input_3 }}</span>
              </div>
            </div>

            <!-- 개선대책 -->
            <div class="mobile-field">
              <label class="mobile-field-label">개선대책</label>
              <div class="mobile-field-input">
                <ml-textarea
                  v-if="!isPrint"
                  :readonly="isReadonly"
                  rows="3"
                  v-model="row.input_4"
                  class="w-full"
                  placeholder="개선대책을 입력하세요"
                />
                <span v-else class="mobile-print-value mobile-print-textarea">{{ row.input_4 }}</span>
              </div>
            </div>

            <!-- 개선일정 -->
            <div class="mobile-field">
              <label class="mobile-field-label">개선일정</label>
              <div class="mobile-field-input">
                <date-selector
                  v-if="!isPrint"
                  v-model="row.input_5"
                  :readonly="isReadonly"
                  class="w-full"
                />
                <span v-else class="mobile-print-value">{{ row.input_5 }}</span>
              </div>
            </div>

            <!-- 개선책임자 -->
            <div class="mobile-field">
              <label class="mobile-field-label">개선책임자</label>
              <div class="mobile-field-input">
                <ml-input
                  v-if="!isPrint"
                  :readonly="isReadonly"
                  class="w-full"
                  v-model="row.input_6"
                  placeholder="개선책임자를 입력하세요"
                />
                <span v-else class="mobile-print-value">{{ row.input_6 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 하단 항목 추가 버튼 (아이템이 있을 때만) -->
      <div class="mobile-add-button-container" v-if="!isPrint && !isReadonly && riskList.length > 0">
        <vs-button
          class="mobile-add-btn"
          color="primary"
          type="filled"
          size="large"
          @click="handleAddRow"
        >
          <i class="feather icon-plus mr-2"></i>
          항목 추가
        </vs-button>
      </div>
    </div>

    <!-- 삭제 확인 팝업 -->
    <vs-popup class="popup-example" title="삭제 확인" :active.sync="showDeleteConfirm">
      <div class="popup-content">
        <p class="delete-message">{{ deleteMessage }}</p>
        <div class="popup-buttons">
          <vs-button
            color="danger"
            type="filled"
            @click="confirmDelete"
          >
            삭제
          </vs-button>
          <vs-button
            color="dark"
            type="flat"
            @click="cancelDelete"
          >
            취소
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import DateSelector from '@/components/selector/DateSelector'
import CompanySelector from '@/components/selector/CompanySelector'
export default {
  name: 'TableRiskFactor',
  components: {
    CompanySelector,
    DateSelector,
    DisasterClassSelector},
  props: {
    tableTitle: String,
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (value) {
        this.riskList = value
      }
    },

  },
  computed: {
    getTableTitle () {
      if (this.tableTitle) return this.tableTitle
      return '주요 위험요인'
    },
    selectedItemsCount () {
      return this.riskList.filter(item => item.is_checked).length
    },
  },
  methods: {
    // 항목추가
    handleAddRow () {
      this.riskList.push({
        is_checked: this.allCheck,
        input_1: '',
        input_2: '',
        input_3: '',
        input_4: '',
        input_5: '',
        input_6: '',
      })
      this.updateList()
    },
    // 선택삭제 확인
    handleRemoveRowConfirm () {
      const selectedCount = this.riskList.filter(item => item.is_checked).length
      if (selectedCount === 0) {
        this.$vs.notify({
          title: '알림',
          text: '삭제할 항목을 선택해주세요.',
          color: 'warning'
        })
        return
      }

      this.deleteMessage = `선택된 ${selectedCount}개의 항목을 삭제하시겠습니까?`
      this.deleteAction = 'batch'
      this.showDeleteConfirm = true
    },
    // 개별 항목 삭제 확인
    handleDeleteSingleItem (index) {
      this.deleteMessage = `${index + 1}번째 항목을 삭제하시겠습니까?`
      this.deleteAction = 'single'
      this.deleteIndex = index
      this.showDeleteConfirm = true
    },
    // 삭제 확인
    confirmDelete () {
      if (this.deleteAction === 'batch') {
        this.handleRemoveRow()
      } else if (this.deleteAction === 'single') {
        this.handleRemoveSingleRow()
      }
      this.showDeleteConfirm = false
    },
    // 삭제 취소
    cancelDelete () {
      this.showDeleteConfirm = false
      this.deleteAction = null
      this.deleteIndex = null
      this.deleteMessage = ''
    },
    // 선택삭제 실행
    handleRemoveRow () {
      for (let i = 0; i < this.riskList.length; i++) {
        if (this.riskList[i].is_checked) {
          this.riskList.splice(i, 1)
          i--
        }
      }

      this.allCheck = false
      this.updateList()

      this.$vs.notify({
        title: '삭제 완료',
        text: '선택된 항목이 삭제되었습니다.',
        color: 'success'
      })
    },
    // 개별 항목 삭제 실행
    handleRemoveSingleRow () {
      this.riskList.splice(this.deleteIndex, 1)
      this.updateList()

      this.$vs.notify({
        title: '삭제 완료',
        text: '항목이 삭제되었습니다.',
        color: 'success'
      })
    },
    // 전체 선택
    handleCheckAll (e) {
      const checked = e.target.checked
      this.riskList.forEach(e => {
        e.is_checked = checked
      })
    },
    // 전체 선택 토글 (모바일 헤더 클릭 시)
    toggleAllCheck () {
      this.allCheck = !this.allCheck
      this.handleCheckAll({ target: { checked: this.allCheck } })
    },
    // update
    updateList () {
      this.$emit('updateList', this.riskList)
    },
  },
  data () {
    return {
      showInfoPopup: false,
      allCheck: false,
      riskList: [],
      showDeleteConfirm: false,
      deleteMessage: '',
      deleteAction: null,
      deleteIndex: null,
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
$mobile-breakpoint: 768px;
$mobile-card-bg: #ffffff;
$mobile-card-border: 1px solid #e8e8e8;
$mobile-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
$mobile-selected-bg: #f0f9ff;
$mobile-selected-border: 1px solid #3b82f6;

.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons {
  display: flex;
  align-items: center;
}

.desktop-only {
  display: inline-flex;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 25px;
}

.vs-checkbox-default {
  margin: 0;
}

.ml-group-checkBox ~ .ml-group-checkBox {
  /*margin-left: 15px;*/
  margin: 0;
}

/* 반응형 레이아웃 제어 */
.desktop-layout {
  display: block !important;
}
.mobile-layout {
  display: none !important;
}

/* 빈 목록 안내 메시지 */
.empty-list-message {
  padding: 60px 20px;
  text-align: center;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  margin-bottom: 20px;
}

.empty-content {
  max-width: 300px;
  margin: 0 auto;
}

.empty-icon {
  font-size: 48px;
  color: #94a3b8;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 24px;
  font-weight: 500;
}

.empty-add-btn {
  min-height: 44px;
  padding: 12px 24px;
  font-weight: 600;

  .feather {
    font-size: 16px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .desktop-layout {
    display: none !important;
  }
  .mobile-layout {
    display: block !important;
  }

  /* 모바일에서 항목추가 버튼 숨김 */
  .desktop-only {
    display: none !important;
  }

  /* 모바일 헤더 최적화 */
  .header-flex {
    .header-buttons {
      .vs-button {
        min-height: 40px;
        font-size: 14px;
        padding: 8px 16px;
      }
    }
  }

  /* 빈 목록 메시지 모바일 최적화 */
  .empty-list-message {
    padding: 40px 16px;
    margin-bottom: 16px;
  }

  .empty-icon {
    font-size: 40px;
  }

  .empty-text {
    font-size: 15px;
  }
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }

  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;

    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}

.row-header__item {
  border-top: $border;
  border-bottom: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.row-header__item.item-col {
  flex-direction: column;
}

.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;

  &__title {
    background-color: $bg;
    height: 100%;
  }

  &__body {
  }
}

.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}

.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}

.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}

.row-color-content {
  background-color: $bg;
  border-right: $border;
}

/* Mobile Styles */
.mobile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: $bg;
  border: $border;
  border-radius: 8px;
  margin-bottom: 15px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #f1f5f9;
    border-color: #94a3b8;
  }

  &:active {
    transform: scale(0.98);
  }

  .mobile-header-text {
    font-weight: 500;
    font-size: 16px;
    color: #374151;
    flex: 1;
  }

  .vs-checkbox {
    transform: scale(1.2); // 터치하기 쉽게 확대
    pointer-events: none; // 체크박스 직접 클릭 방지
  }
}

.mobile-cards-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-card {
  background: $mobile-card-bg;
  border: $mobile-card-border;
  border-radius: 12px;
  box-shadow: $mobile-card-shadow;
  overflow: hidden;
  transition: all 0.3s ease;

  &.selected {
    background: $mobile-selected-bg;
    border: $mobile-selected-border;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }

  &.print-mode {
    box-shadow: none;
    border: $border;
    margin-bottom: 10px;
  }
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;

  &.print-header {
    background: $bg;
    justify-content: center;
  }

  .mobile-card-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .card-index {
    font-weight: 600;
    font-size: 16px;
    color: #1e293b;
  }

  .vs-checkbox {
    transform: scale(1.2);
  }

  .mobile-delete-btn {
    min-height: 32px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 6px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(220, 38, 38, 0.3);
    }
  }
}

.mobile-card-content {
  padding: 20px;
}

.mobile-field {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.mobile-field-label {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  line-height: 1.4;
}

.mobile-field-input {
  .vs-select,
  .vs-input,
  .vs-textarea {
    min-height: 44px; // 터치 친화적 크기

    .vs-select__input,
    .vs-input__input,
    .vs-textarea__input {
      font-size: 16px; // iOS 줌 방지
      padding: 12px 16px;
    }
  }

  .vs-select {
    .vs-select__input {
      border-radius: 8px;
      border: 1px solid #d1d5db;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }

  .vs-textarea {
    .vs-textarea__input {
      border-radius: 8px;
      border: 1px solid #d1d5db;
      min-height: 80px;
      resize: vertical;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }
}

.mobile-print-value {
  display: block;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  min-height: 20px;

  &.mobile-print-textarea {
    min-height: 60px;
    white-space: pre-wrap;
    line-height: 1.5;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .desktop-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }

  /* 테이블 인쇄 최적화 */
  .desktop-table-header,
  .desktop-table-row {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}

/* 모바일 하단 항목 추가 버튼 */
.mobile-add-button-container {
  margin-top: 20px;
  padding: 0 5px;
}

.mobile-add-btn {
  width: 100%;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .feather {
    font-size: 18px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3);
  }
}

/* 삭제 확인 팝업 스타일 */
.popup-content {
  padding: 20px;
  text-align: center;
}

.delete-message {
  font-size: 16px;
  color: #374151;
  margin-bottom: 25px;
  line-height: 1.5;
}

.popup-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;

  .vs-button {
    min-width: 100px;
    min-height: 40px;
    font-weight: 600;
  }
}

/* 작은 모바일 화면 최적화 */
@media (max-width: 480px) {
  .mobile-card-content {
    padding: 15px;
  }

  .mobile-header {
    padding: 12px;
  }

  .mobile-card-header {
    padding: 12px 15px;

    .mobile-card-header-left {
      .card-index {
        font-size: 14px;
      }
    }

    .mobile-delete-btn {
      min-height: 28px;
      padding: 6px 10px;
      font-size: 11px;
    }
  }

  .mobile-add-btn {
    min-height: 48px;
    font-size: 15px;

    .feather {
      font-size: 16px;
    }
  }

  .popup-buttons {
    flex-direction: column;
    gap: 10px;

    .vs-button {
      width: 100%;
    }
  }
}
</style>
